import { v4 as uuidv4 } from 'uuid';

export const SESSION_TOKEN = 'session_token';

export function getSessionToken(): string {
  let token = localStorage.getItem(SESSION_TOKEN);
  if (!token) {
    token = uuidv4();
    localStorage.setItem(SESSION_TOKEN, token);
  }
  return token;
}

export function refreshSessionToken(): string {
  const token = uuidv4();
  localStorage.setItem(SESSION_TOKEN, token);
  return token;
}